import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import "./App.css";
import { Layout } from "./components";
import Login from "./pages/Login";
import DrivePage from "./pages/DrivePage";
import TokenDebugPage from "./pages/TokenDebugPage";
import PublicLinksPage from "./pages/PublicLinksPage";
import Error404 from "./components/Erros_control/Error404";
import FileLink from "./pages/FileLink";
import { cognitoConfig } from "./config";

function App() {
  Amplify.configure({
    Auth: {
      Cognito: cognitoConfig,
    },
  });

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Layout />,
      children: [
        {
          index: true,
          element: <DrivePage />,
        },
        {
          path: "links",
          element: <PublicLinksPage />,
        },
      ],
    },
    {
      path: "/debug-token",
      element: <TokenDebugPage />,
    },
    {
      path: "*", // Ruta "catch-all"
      element: <Error404 />, // Componente de error 404
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/file/:linkId",
      element: <FileLink />,
    },
  ]);

  return (
    <Authenticator.Provider>
      <RouterProvider router={router} />
    </Authenticator.Provider>
  );
}

export default App;
